var actions = {
	next: "Volgende",
	confirm: "Bevestigen",
	"continue": "Doorgaan"
};
var errors = {
	unknown: "Er is een onbekende fout opgetreden",
	contactSupport: "Er is een fout opgetreden. Neem contact op met support.",
	tryAgain: "Er is een fout opgetreden. Probeer het opnieuw.",
	submit: "Het verzenden is mislukt."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Inloggen met {name}",
	signupWith: "Aanmelden met {name}"
};
var alreadyHaveAccount = {
	company: "Heb je al een {company}-account?",
	text: "Heb je al een Streamlabs ID?",
	link: "Inloggen"
};
var noAccount = {
	text: "Heb je nog geen account?",
	link: "Aanmelden"
};
var validation = {
	email: {
		invalid: "Voer een geldig e-mailadres in"
	},
	password: {
		required: "Wachtwoord is vereist",
		min: "Wachtwoord moet meer dan 8 tekens bevatten",
		number: "Wachtwoord moet een cijfer bevatten",
		upper: "Wachtwoord moet een hoofdletter bevatten",
		special: "Wachtwoord moet een speciaal teken bevatten"
	},
	username: {
		invalid: "Naam moet ten minste 5 tekens bevatten"
	},
	code: {
		minmax: "Code moeten tussen de 6 en 10 tekens lang zijn"
	}
};
var poweredBy = "Mogelijk gemaakt door <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Bedrijf niet gevonden!",
		desc: "Probeer het later nog eens of neem contact op met support."
	},
	company: {
		logoAlt: "{company}-logo"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6-cijferige authenticatiecode/8-cijferige back-upcode",
	successText: "Gelukt! Je wordt omgeleid...",
	remember: "Dit apparaat 30 dagen onthouden"
};
var createTfa = {
	scan: {
		title: "Tweefactorauthenticatie inschakelen",
		lead: "Klik/kopieer of scan de code hieronder met de authenticatie-app van je voorkeur. We raden apps zoals <app0 />, <app1 /> of <app2 /> aan om je codes veilig te bewaren.",
		copied: "Gekopieerd!",
		instructions: "Of voer deze code handmatig in je authenticatie-app in.",
		copy: "Code kopiëren",
		proceed: "Bevestiging"
	},
	confirm: {
		title: "Je tweefactorauthenticatie bevestigen",
		lead: "Voer hieronder de gegenereerde 2FA-code in om te bevestigen en tweefactorauthenticatie in te schakelen.",
		label: "2FA-code (6 cijfers)",
		verify: "Code verifiëren",
		next: "Gelukt! Volgende stap"
	},
	save: {
		title: "Herstelcodes opslaan",
		lead: "Bewaar je herstelcodes hieronder voor het geval je toegang tot je tweefactorauthenticatie verliest. De codes zijn na het sluiten van dit venster niet meer beschikbaar.",
		label: "Herstelcodes",
		download: "Herstelcodes downloaden",
		copied: "Codes gekopieerd!",
		finished: "Voltooid"
	}
};
var emailLoginForm = {
	buttonText: "Inloggen",
	emailPlaceholder: "E-mailadres",
	passwordPlaceholder: "Wachtwoord"
};
var emailSignupForm = {
	buttonText: "Aanmelden",
	emailPlaceholder: "E-mailadres instellen",
	passwordPlaceholder: "Wachtwoord instellen",
	usernamePlaceholder: "Je naam",
	ageLabel: "Geboortedatum",
	agePlaceholder: "MM/DD/JJJJ",
	agreeText: "Ik ga akkoord met de <terms>Algemene voorwaarden</terms> en het <privacy>Privacybeleid</privacy> van Streamlabs.",
	agreeError: "Gelieve de algemene voorwaarden van Streamlabs te accepteren"
};
var ageInput = {
	invalidDate: "Voer een geldige geboortedatum in",
	futureDate: "Geboortedatum moet in het verleden liggen",
	minDate: "Data vóór het jaar {year} zijn niet toegestaan",
	minAge_one: "Je moet {years} jaar of ouder zijn om Streamlabs te kunnen gebruiken",
	minAge_two: "Je moet {years} jaar of ouder zijn om Streamlabs te kunnen gebruiken",
	minAge_other: "Je moet {years} jaar of ouder zijn om Streamlabs te kunnen gebruiken"
};
var forgotPasswordForm = {
	emailPlaceholder: "E-mailadres",
	back: "Terug naar inloggen",
	successText: "Gelukt! We hebben je een wachtwoordherstelcode gestuurd",
	buttonText: "E-mail voor wachtwoordherstel aanvragen",
	create: {
		successText: "Gelukt! We hebben je een verificatiecode gestuurd om je op weg te helpen!",
		buttonText: "Verificatiecode aanvragen"
	},
	errors: {
		notFound: "Geen account met dit e-mailadres gevonden"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Wachtwoord vergeten?",
	lead: "Als je je wachtwoord moet herstellen, voer dan hieronder je e-mailadres in en dan sturen we je een e-mail om het proces te starten.",
	resetTitle: "Wachtwoord herstellen",
	resetLead: "Als het goed is heb je via e-mail een code ontvangen. Vul het formulier in om je wachtwoord te herstellen.",
	create: {
		title: "Je wachtwoord maken",
		lead: "Gefeliciteerd met het maken van je Streamlabs-ID! Nog één stap en je kunt inloggen in heel Streamlabs!",
		resetTitle: "Een wachtwoord kiezen",
		resetLead: "Als het goed is heb je via e-mail een code ontvangen. Gebruik deze en vul het formulier in om je wachtwoord in te stellen."
	},
	successText: "Gelukt! Je wordt omgeleid...",
	signInTitle: "Heb je al een account?",
	signInBtn: "Inloggen"
};
var checkTfaCard = {
	title: "Controle tweefactorauthenticatie",
	lead: "Voer hieronder een 2FA-code in om door te gaan.",
	successText: "2FA bevestigd!",
	back: "Terug"
};
var verifyEmailCard = {
	title: "E-mailadres verifiëren",
	lead: "Controleer je inbox op een 8-cijferige code van Streamlabs en voer die hieronder in.",
	back: "Terug",
	successText: "E-mail geverifieerd!"
};
var upgradeCard = {
	confirm: {
		title: "Verbinding met {company} bevestigen",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Voortaan kun je bij {company} inloggen met het verstrekte e-mailadres en wachtwoord.",
			"Je kunt je ID gebruiken om toegang te krijgen tot alle andere producten van Streamlabs en je andere bestaande accounts koppelen.",
			"Deze verandering heeft geen gevolgen voor je account bij {company}."
		],
		button: "Bevestigen",
		cancel: "Annuleren",
		switchAccount: "Account wisselen",
		success: "Verbinden..."
	},
	confirmed: {
		title: "Gelukt!",
		subtitle: "Je Streamlabs ID is aangemaakt en je account bij {company} is gekoppeld.",
		text: "Je kunt je Streamlabs ID voor alle Streamlabs-producten gebruiken. Als je bestaande accounts hebt, kun je ze in elke app met deze ID koppelen.",
		button: "Sluiten"
	},
	error: {
		user: "Gebruikersidentificatie mislukt. Probeer nog eens in te loggen of neem contact op met support."
	}
};
var confirmCard = {
	confirm: {
		title: "Verbinding met {company} bevestigen",
		subtitle: "We hebben een account gevonden met overeenkomend e-mailadres. Wil je dit account samenvoegen met Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Je kunt bij {company} inloggen met het e-mailadres en wachtwoord dat je via Streamlabs ID hebt verstrekt.",
			"Je kunt je ID gebruiken om toegang te krijgen tot alle andere producten van Streamlabs en je andere bestaande accounts koppelen.",
			"Deze verandering heeft geen gevolgen voor je bedrijfsaccount."
		],
		button: "Bevestigen",
		cancel: "Annuleren",
		switchAccount: "Account wisselen",
		success: "Verbinden..."
	},
	confirmed: {
		title: "Gelukt!",
		subtitle: "Je Streamlabs ID is aangemaakt en je account bij {company} is gekoppeld.",
		text: "Je kunt je Streamlabs ID voor alle Streamlabs-producten gebruiken. Als je bestaande accounts hebt, kun je ze in elke app met deze ID koppelen.",
		button: "Sluiten"
	},
	error: {
		user: "Gebruikersidentificatie mislukt. Probeer nog eens in te loggen of neem contact op met support."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Je ID is al verbonden met een account bij {company}.",
		subtitle: "Wil je het verbonden account ontkoppelen en je huidige Streamlabs-account koppelen?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Je kunt bij Streamlabs inloggen met het e-mailadres en wachtwoord dat je voor Streamlabs ID hebt verstrekt.",
			"Je kunt je ID gebruiken om toegang te krijgen tot alle andere producten van Streamlabs en je andere bestaande accounts koppelen.",
			"Deze verandering heeft geen gevolgen voor je account bij Streamlabs."
		],
		button: "Bevestigen",
		cancel: "Annuleren",
		switchAccount: "Account wisselen",
		success: "Verbinden...",
		agreeLabel: "Ik begrijp dat ik door deze verbinding te maken de toegang verlies tot het bestaande account bij {company} dat is gelinkt aan Streamlabs ID."
	},
	confirmed: {
		title: "Gelukt!",
		subtitle: "Je Streamlabs ID is aangemaakt en je account bij {company} is gekoppeld.",
		text: "Je kunt je Streamlabs ID voor alle Streamlabs-producten gebruiken. Als je bestaande accounts hebt, kun je ze in elke app met deze ID koppelen.",
		button: "Sluiten"
	},
	error: {
		user: "Gebruikersidentificatie mislukt. Probeer nog eens in te loggen of neem contact op met support."
	}
};
var loginCard = {
	title: "Inloggen",
	lead: "Inloggen bij <company>{company}</company> met <id>Streamlabs ID</id>",
	accountExists: "Het lijkt erop dat je een <b>Streamlabs ID</b> hebt. Probeer met je e-mailadres in te loggen.",
	forgotPassword: "Wachtwoord vergeten?",
	successText: "Gelukt! Je wordt omgeleid...",
	signInTitle: "Inloggen op een platform"
};
var loginSourcesCard = {
	title: "Inloggen",
	lead: "Inloggen met e-mailadres/wachtwoord",
	withSlId: "Inloggen bij Streamlabs ID",
	noAccountMessage: "We zien geen account dat met deze inlogmethode is gekoppeld. Probeer een andere inlogmethode of <signup>meld je aan</signup> als je dat nog niet hebt gedaan.",
	accountExistsMessage: "Je Twitch-e-mailadres is al met een Streamlabs-account gekoppeld. Log in met je e-mailadres en wachtwoord van Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "E-mailadres",
	codePlaceholder: "E-mailcode van 6 tot 8 cijfers",
	tfaCodePlaceholder: "2FA-code",
	newPasswordPlaceholder: "Nieuw wachtwoord",
	tfaError: "Herstelcode moet tussen 6 en 10 tekens bevatten",
	next: "Code ontvangen?",
	back: "Terug naar Wachtwoord vergeten",
	buttonText: "Wachtwoord wijzigen",
	successText: "Wachtwoord is hersteld",
	create: {
		back: "Terug naar start",
		buttonText: "Wachtwoord instellen",
		successText: "Wachtwoord succesvol ingesteld"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Huidig wachtwoord",
	newPasswordPlaceholder: "Nieuw wachtwoord",
	newPasswordConfirmationPlaceholder: "Nieuw wachtwoord bevestigen",
	buttonText: "Wachtwoord wijzigen",
	successText: "Wachtwoord is bijgewerkt",
	newPasswordConfirmationError: "Nieuwe wachtwoorden komen niet overeen",
	back: "Terug naar dashboard"
};
var changePasswordCard = {
	title: "Wachtwoord wijzigen",
	lead: "Voer hieronder je huidige wachtwoord en een nieuw wachtwoord in.",
	successText: "Wachtwoord is bijgewerkt"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6-cijferige authenticatiecode/8-cijferige back-upcode",
	successText: "2FA is verwijderd",
	removeBtn: "Bevestigen en verwijderen"
};
var removeTfaCard = {
	title: "Tweefactorauthenticatie verwijderen",
	lead: "Voer hieronder een 2FA-bevestigingscode in om tweefactorauthenticatie uit je account te verwijderen.",
	successText: "2FA is verwijderd",
	back: "Terug naar dashboard"
};
var verifyEmailForm = {
	codePlaceholder: "8-cijferige code uit e-mail",
	tfaCodePlaceholder: "2FA-code",
	emailPlaceholder: "E-mailadres",
	buttonText: "E-mailadres verifiëren",
	successText: "E-mailadres goed geverifieerd",
	requestBtn: "Nieuwe code aanvragen",
	requestingBtn: "Aanvragen...",
	requestSuccess: "Er is een code naar je e-mailadres gestuurd",
	requestAgain: "Stuur een nieuwe aanvraag over {seconds} seconden",
	tfaError: "Herstelcode moet tussen 6 en 10 tekens bevatten",
	back: "Terug"
};
var signupCard = {
	title: "Aanmelden",
	lead: "Maak een <id>Streamlabs ID</id>-account aan om <company>{company}</company> te gebruiken",
	successText: "Gelukt! Je wordt omgeleid..."
};
var signupSourcesCard = {
	title: "Aanmelden",
	lead: "Maak een <id>Streamlabs ID</id>-account aan om <company>{company}</company> te gebruiken",
	withSlId: "Streamlabs ID aanmaken"
};
var connectCard = {
	connect: {
		title: "Account kiezen",
		lead: "om door te gaan naar <b>{company}</b>",
		authorize: "Autoriseren",
		authorizeSuccess: "Gelukt!",
		cancel: "Annuleren",
		disclaimer: {
			streamlabs: "Als je doorgaat, deel je je Streamlabs ID (naam, e-mailadres, taalvoorkeuren en profielfoto) met <b>{company}</b>. Door een account te autoriseren met <b>{company}</b>, ga je hierbij akkoord met het <privacy>privacybeleid</privacy> en de <terms>servicevoorwaarden</terms> van <b>{company}</b>.",
			"default": "Om door te gaan, deel Streamlabs je naam, e-mailadres, taalvoorkeuren en profielfoto met <b>{company}</b>. Door een account te autoriseren met <b>{company}</b>, ga je hierbij akkoord met het <privacy>privacybeleid</privacy> en de <terms>servicevoorwaarden</terms> van <b>{company}</b>."
		},
		emailRequired: "Je moet je e-mailadres verifiëren om door te gaan",
		tfaRequired: "Tweefactorauthenticatie is vereist om door te gaan"
	},
	login: {
		title: "Inloggen bij {company}",
		lead: "Je moet ingelogd zijn om accounts te koppelen",
		loginBtn: "Doorgaan naar inloggen"
	},
	error: {
		title: "Inloggen bij {company}",
		lead: "Je verzoek kan momenteel niet worden geautoriseerd",
		verifyEmail: "E-mailadres verifiëren",
		verify2fa: "2FA verifiëren"
	},
	"switch": {
		btn: "Ander account gebruiken"
	}
};
var appsDropdown = {
	label: "Streamlabs-producten en -apps",
	viewMore: "Uitvouwen",
	viewLess: "Samenvouwen"
};
var platformButtons = {
	loginWithPlatform: "Inloggen op een platform",
	signUpWithPlatform: "Aanmelden bij een platform",
	signUpLead: "We ondersteunen livestreaming op nog veel meer platforms, dit zijn alleen maar de aanmeldingsopties."
};
var ultraCheckoutCard = {
	title: "Maak je livestreams, branding, montage en meer professioneler met <b>Streamlabs Ultra</b>",
	badge: "Inclusief <b>{planName}</b>",
	totalValue: "{price, currency} waarde",
	price: {
		month: "{price, currency}/mnd",
		year: "{price, currency}/jr"
	},
	description: {
		month: "Krijg toegang tot premiumfuncties uit de volledige suite, waaronder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> en meer, beschikbaar voor één betaalbare prijs.",
		year: "Krijg toegang tot premiumfuncties uit de volledige suite, waaronder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> en meer, beschikbaar voor één betaalbare prijs."
	},
	seeIncluded: "Meer informatie",
	buyNow: "Upgraden"
};
var ultraCheckoutBanner = {
	title: "Maak je livestreams, branding, montage en meer professioneler met <b>Streamlabs Ultra</b>",
	badge: "Inclusief <b>{planName}</b>",
	totalValue: "{price, currency} waarde",
	price: {
		month: "{price, currency}/mnd",
		year: "{price, currency}/jr"
	},
	description: {
		month: "Krijg toegang tot premiumfuncties uit de volledige suite, waaronder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> en meer, beschikbaar voor één betaalbare prijs. <link />",
		year: "Krijg toegang tot premiumfuncties uit de volledige suite, waaronder <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> en meer, beschikbaar voor één betaalbare prijs. <link />"
	},
	seeIncluded: "Meer informatie",
	buyNow: "Upgraden"
};
var connect = {
	waitMessage: "Gegevens samenvoegen. Sluit dit venster niet."
};
var verifyPasswordCard = {
	success: "Wachtwoord geverifieerd",
	title: "Authenticeer opnieuw om te verifiëren",
	lead: "Log in met je bestaande e-mailadres en wachtwoord om door te gaan met het updaten van je Streamlabs ID.",
	buttonText: "Volgende"
};
var emailChangeForm = {
	agreeError: "Bevestig dat je deze actie begrijpt",
	buttonText: "Volgende",
	emailPlaceholder: "Nieuw e-mailadres",
	agreeText: "Ik begrijp dat mijn Streamlabs ID na verificatie zal veranderen voor alle Streamlabs-producten waarmee de ID verbonden is."
};
var verifyNewEmailCard = {
	title: "Je Streamlabs ID wijzigen",
	lead: "Geef een nieuw e-mailadres op om te gebruiken als je Streamlabs ID. We sturen een 6- tot 8-cijferige verificatiecode naar dit adres.",
	successText: "Nieuw e-mailadres beschikbaar"
};
var verifyNewEmailOwnershipCard = {
	title: "Verifieer je bijgewerkte Streamlabs ID",
	lead: "Controleer je inbox op een 8-cijferige code van Streamlabs en voer die hieronder in.",
	buttonText: "Bevestigen",
	back: "Terug",
	codePlaceholder: "8-cijferige code uit e-mail",
	successText: "Eigenaar e-mailadres geverifieerd"
};
var verifyTfaCard = {
	title: "Code voor tweefactorauthenticatie",
	lead: "Voer de 6-cijferige verificatiecode van je authenticatie-app in.",
	codePlaceholder: "6-cijferige code",
	buttonText: "Bevestigen",
	successText: "Tweefactorauthenticatie bevestigd",
	back: "Terug"
};
var ageGateForm = {
	ageLabel: "Geboortedatum",
	agePlaceholder: "MM/DD/JJJJ"
};
var ageGateCard = {
	title: "Voltooi het instellen van je account",
	lead: {
		years: "Je moet {years} of ouder zijn om een account aan te maken. <br />Voer je geboortedatum in om het instellen te voltooien.",
		noYears: "Je moet je geboortedatum opgeven om een account aan te maken. <br />Voer deze in om het instellen te voltooien."
	},
	successText: "Gefeliciteerd! Je account is ingesteld."
};
var nlNL = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { nlNL as n };
//# sourceMappingURL=nl-NL.es.js.map
